import { Directive, ElementRef, Renderer2, AfterViewInit, RendererStyleFlags2 } from '@angular/core';
import { CardAutoSizeMessage, Messenger } from '@app/shared';

@Directive({
  selector: '[cardAutoSize]',
  standalone: false
})
export class CardAutoSizeDirective implements AfterViewInit {
  private lastHeight: number | null = null;

  constructor(private el: ElementRef, private renderer: Renderer2, private messenger: Messenger) {}

   ngAfterViewInit(): void {
    this.messenger.subscribe(this, CardAutoSizeMessage, (message) => {
      this.lastHeight = message.height;
      this.applyHeight(); // apply now
    });

    
    const observer = new MutationObserver(() => {
      this.applyHeight();
    });

    observer.observe(this.el.nativeElement, {
      childList: true,
      subtree: true
    });
  }

  private applyHeight() {
    const cardContainer = this.el.nativeElement.querySelector('.card-auto-height-selector');
    if (cardContainer && this.lastHeight != null) {
      this.renderer.setStyle(
        cardContainer,
        'height',
        `${this.lastHeight}px`,
        RendererStyleFlags2.Important
      );
      console.log('[cardAutoSize] Height applied:', this.lastHeight);
    }
  }
}